var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7851 49.247C45.011 49.247 49.2475 45.0106 49.2475 39.7846C49.2475 34.5587 45.011 30.3223 39.7851 30.3223C34.5592 30.3223 30.3228 34.5587 30.3228 39.7846C30.3228 45.0106 34.5592 49.247 39.7851 49.247Z",
    fill: "#F43030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9086 0 0 17.9086 0 40C0 53.1442 6.34038 64.8069 16.129 72.0984V39.7849C16.129 26.7201 26.7201 16.129 39.7849 16.129C49.4844 16.129 57.816 21.9691 61.4668 30.3226H78.8186C74.491 12.9074 58.754 0 40 0Z",
    fill: "#262532"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3193 53.1182C55.0598 59.3489 47.9026 63.4407 39.7851 63.4407C36.4198 63.4407 33.2211 62.7335 30.3228 61.4667V78.8185C33.4219 79.5886 36.6628 79.9999 40.0002 79.9999C54.0064 79.9999 66.3197 72.7943 73.4626 61.8937L59.3193 53.1182Z",
    fill: "#262532"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4668 30.3223H53.5483V49.247H61.4668H62.6303L78.8185 30.3223H61.4668Z",
    fill: "#728EC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d7931f4d7647dcf9b119a2574c4d830.svg";
export { ForwardRef as ReactComponent };